import { render } from "./calendarAppuntamenti.vue?vue&type=template&id=65168a60&ts=true"
import script from "./calendarAppuntamenti.vue?vue&type=script&lang=ts"
export * from "./calendarAppuntamenti.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__